export default [
  {
    path: "/pvtv/project/map",
    name: "map",
    meta: {
      title: "地图监控",
      breadcrumb: ["数据大屏", "地图监控"],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ "@/views/pvtv_views/project/map.vue"
      ),
  },
  {
    path: "/pvtv/project/centermonitor",
    name: "centermonitor",
    meta: {
      title: "集中监控",
      breadcrumb: ["数据大屏", "集中监控"],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ "@/views/pvtv_views/project/centermonitor.vue"
      ),
  },
  {
    path: "/pvtv/project/workbench",
    name: "workbench",
    meta: {
      title: "工作台",
      breadcrumb: ["项目中心", "工作台"],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ "@/views/pvtv_views/project/workbench.vue"
      ),
  },
  {
    path: "/pvtv/project/analysis",
    name: "analysis",
    meta: {
      title: "分析页",
      breadcrumb: ["项目中心", "分析页"],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ "@/views/pvtv_views/project/analysis.vue"
      ),
  },
  {
    path: "/pvtv/project/configuration",
    name: "configuration",
    meta: {
      title: "项目配置",
      breadcrumb: ["项目中心", "项目配置"],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ "@/views/pvtv_views/project/configuration.vue"
      ),
  },
  {
    path: "/pvtv/project/realmonitor",
    name: "realmonitor",
    meta: {
      title: "实时监控",
      breadcrumb: ["数据分析", "实时监控"],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ "@/views/pvtv_views/project/realmonitor.vue"
      ),
  },
  {
    path: "/pvtv/project/historyreport",
    name: "historyreport",
    meta: {
      title: "历史报表",
      breadcrumb: ["报表中心", "历史报表"],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ "@/views/pvtv_views/project/historyreport.vue"
      ),
  },
  {
    path: "/pvtv/project/personal",
    name: "personal",
    meta: {
      title: "个人中心",
      breadcrumb: ["个人中心", "个人中心"],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ "@/views/pvtv_views/project/personal.vue"
      ),
  },
  {
    path: "/pvtv/project/message",
    name: "message",
    meta: {
      title: "消息中心",
      breadcrumb: ["消息中心", "消息中心"],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ "@/views/pvtv_views/project/message.vue"
      ),
  },
  {
    path: "/pvtv/project/pushmanage",
    name: "pushmanage",
    meta: {
      title: "推送管理",
      breadcrumb: ["消息中心", "推送管理"],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ "@/views/pvtv_views/project/pushmanage.vue"
      ),
  },
  {
    path: "/pvtv/project/activealarm",
    name: "activealarm",
    meta: {
      title: "活跃报警",
      breadcrumb: ["报警管理", "活跃报警 "],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ "@/views/pvtv_views/project/activealarm.vue"
      ),
  },
  {
    path: "/pvtv/project/historyalarm",
    name: "historyalarm",
    meta: {
      title: "历史报警",
      breadcrumb: ["报警管理", "历史报警 "],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ "@/views/pvtv_views/project/historyalarm.vue"
      ),
  },
  {
    path: "/pvtv/project/video",
    name: "video",
    meta: {
      title: "视频管理",
      breadcrumb: ["视频管理", "视频管理"],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ "@/views/pvtv_views/project/video.vue"
      ),
  },
  {
    path: "/pvtv/project/assetoverview",
    name: "assetoverview",
    meta: {
      title: "资产总览",
      breadcrumb: ["资产管理", "资产总览 "],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ "@/views/pvtv_views/project/assetoverview.vue"
      ),
  },
  {
    path: "/pvtv/project/devicemanage",
    name: "devicemanage",
    meta: {
      title: "设备管理",
      breadcrumb: ["资产管理", "设备管理"],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ "@/views/pvtv_views/project/devicemanage.vue"
      ),
  },
  {
    path: "/pvtv/project/archives",
    name: "archives",
    meta: {
      title: "设备档案",
      breadcrumb: ["资产管理", "设备档案"],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ "@/views/pvtv_views/project/archives.vue"
      ),
  },
  {
    path: "/pvtv/project/overview",
    name: "overview",
    meta: {
      title: "运维总览",
      breadcrumb: ["运维服务", "运维总览"],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ "@/views/pvtv_views/project/overview.vue"
      ),
  },
  {
    path: "/pvtv/project/usermanage",
    name: "usermanage",
    meta: {
      title: "用户管理",
      breadcrumb: ["人员管理", "用户管理"],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ "@/views/pvtv_views/project/usermanage.vue"
      ),
  },
  {
    path: "/pvtv/project/role",
    name: "role",
    meta: {
      title: "角色管理 ",
      breadcrumb: ["人员管理", "角色管理"],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ "@/views/pvtv_views/project/role.vue"
      ),
  },
  {
    path: "/pvtv/project/permission",
    name: "permission",
    meta: {
      title: "权限管理",
      breadcrumb: ["人员管理 ", "权限管理"],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ "@/views/pvtv_views/project/permission.vue"
      ),
  },
  {
    path: "/pvtv/project/log",
    name: "log",
    meta: {
      title: "操作日志",
      breadcrumb: ["操作日志", "操作日志"],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ "@/views/pvtv_views/project/log.vue"
      ),
  },
  {
    path: "/pvtv/project/download",
    name: "download",
    meta: {
      title: "下载中心",
      breadcrumb: ["下载中心", "下载中心"],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ "@/views/pvtv_views/project/download.vue"
      ),
  },
  {
    path: "/pvtv/project/help",
    name: "help",
    meta: {
      title: "帮助文档",
      breadcrumb: ["帮助文档", "帮助文档"],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ "@/views/pvtv_views/project/help.vue"
      ),
  },
];
